module.exports = __webpack_public_path__ + "static/media/logo-code7-boteria-beta.09ee6dd6.svg";